import React from 'react'
import './Index.css'
import Home from "./Home/Index"
import Steps from "./Steps/Index"
// import {Navbar, NavItem, Nav} from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import Navbar from "./Navbar/Index"
import Testimonials from "./Testimonails/Index"
import AboutUs from './About/Index';
import Footer from './Footer/Index';


const Index = () => {
    return (
        <div className="main" >
          {/*<Navbar />*/ } 
          <Home />
          <Steps />
       
        <AboutUs />
        <Footer />
        </div>
    )
}

export default Index
